// src/hooks/useFirebaseMessaging.ts
import { messaging } from '@/config/firebase';
import { markNotificationAsRead } from '@/services/notification';
import { notification } from 'antd';
import { MessagePayload, onMessage } from 'firebase/messaging';
import { useEffect } from 'react';

export const useFirebaseMessaging = () => {
  useEffect(() => {
    if (!messaging) {
      return;
    }

    const unsubscribe = onMessage(messaging, (payload: MessagePayload) => {
      console.log('payload', payload);
      if (payload.data) {
        const title = payload.data.title || 'Thông báo mới';
        const body = payload.data.body || '';

        notification.info({
          message: title,
          description: body,
          placement: 'bottomLeft',
          duration: 5,
          style: {
            cursor: 'pointer',
          },
          onClick: () => {
            if (payload.data?.url) {
              markNotificationAsRead(Number(payload.data?.id)).catch(() => {});
              window.location.href = payload.data?.url;
              notification.destroy();
            }
          },
        });
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);
};
